import { useNavigate, useLocation } from "react-router-dom";
import { getCertificateDisplay } from "../../api/api";

const FILE_KB = 1024;
const FILE_MB = 1024 * 1024;
const FILE_GB = 1024 * 1024 * 1024;
const borderDecimalNumber = 9;

function MainComponent({ handleLoading }) {

    document.title = "添付ファイル アップロード| ファーストコンタクトセンター";
    const navigate = useNavigate();
    const location = useLocation();
    const caseId = location.state.caseId;
    const contactId = location.state.contactId;
    const fileNames = location.state.fileNames;

    const getFirstDecimalPart = (num) => {
        let getDecimalVal = num.toString().indexOf(".");
        let decimalPart = num.toString().substring(getDecimalVal + 1);
        let firstNum = decimalPart.charAt(0);
        return parseInt(firstNum);
    }

    const showSize = (size) => {
        let fileSize = size;

        if (fileSize < FILE_KB) {
            let newFile = Math.round(fileSize);
            return (
                <div>
                    {newFile}B
                </div>
            )
        }

        if (fileSize >= FILE_KB && fileSize < FILE_MB) {
            let newFile = (fileSize / 1024);
            if (getFirstDecimalPart(newFile) >= borderDecimalNumber) {
                newFile = Math.floor(newFile * 10) / 10;
                return (
                    <div>
                        {newFile}KB
                    </div>
                )
            } else {
                newFile = Math.round(newFile * 10) / 10;
                return (
                    <div>
                        {newFile}KB
                    </div>
                )
            }
        }

        if (fileSize >= FILE_MB && fileSize < FILE_GB) {
            let newFile = (fileSize / 1024 / 1024);
            if (getFirstDecimalPart(newFile) >= borderDecimalNumber) {
                newFile = Math.floor(newFile * 10) / 10;
                return (
                    <div>
                        {newFile}MB
                    </div>
                )
            } else {
                newFile = Math.round(newFile * 10) / 10;
                return (
                    <div>
                        {newFile}MB
                    </div>
                )
            }
        }

        if (fileSize >= FILE_GB) {
            let newFile = (fileSize / 1024 / 1024 / 1024);
            if (getFirstDecimalPart(newFile) >= borderDecimalNumber) {
                newFile = Math.floor(newFile * 10) / 10;
                return (
                    <div>
                        {newFile}GB
                    </div>
                )
            } else {
                newFile = Math.round(newFile * 10) / 10;
                return (
                    <div>
                        {newFile}GB
                    </div>
                )
            }
        }
    }

    const goNext = async () => {
        handleLoading(true);
        const html_body = await getCertificateDisplay(contactId);
        const win = await window.open("預り証", "_blank");
        win.document.write(html_body);
        win.document.close();
        handleLoading(false);
        navigate("/inquiry_completion", { state: { page: true } });
    };

    const fileList = fileNames.map((fileName, index) => {
        return <tr key={"filedata-" + index}>
            <td key={"filename-" + index}>{fileName.name}</td>
            <td key={"filesize-" + index}>{showSize(fileName.size)}</td>
        </tr>
    });

    return (

        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>添付ファイル アップロード</span>
                    </h2>

                    <div className="mod-txt">
                        <p>
                        </p>
                    </div>
                    <h4 className="mod-hdg-l4-02">
                        資料アップロード先
                    </h4>
                    <div className="mod-txt">
                        <ul>
                            <li>受付番号：<span id="receipt_no">{caseId}</span></li>
                        </ul>
                    </div>

                    <h4 className="mod-hdg-l4-02">
                        アップロード資料
                    </h4>
                    <div className="mod-tbl">
                        <table>
                            <colgroup>
                                <col className="w-60" />
                                <col className="w-15" />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th>アップロード済資料</th>
                                    <th>ファイルサイズ</th>
                                </tr>
                            </thead>
                            <tbody id="upload_file_list">
                                {fileList}
                            </tbody>
                        </table>
                    </div>
                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button type="button" className="btn_default_select"
                                onClick={goNext}>OK</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MainComponent;